import { ApiPaths } from "../../../api/ApiPaths";
import { CareRecipientId } from "../../../../domain/care_recipient/CareRecipientId";
import { RegularGoingOut } from "../../../../domain/assessment/RegularGoingOut";
import { RegularVisit } from "../../../../domain/assessment/RegularVisit";
import { ApiRequest } from "../../../api/ApiRequest";

export type GetAssessmentScheduleSuccessResponseType = {
    regularGoingOut: [{
        title: string,
        startTime: string,
        endTime: string,
        week1: boolean,
        week2: boolean,
        week3: boolean,
        week4: boolean,
        week5: boolean,
        sunday: boolean,
        monday: boolean,
        tuesday: boolean,
        wednesday: boolean,
        thursday: boolean,
        friday: boolean,
        saturday: boolean,
    }],
    regularVisit: [{
        title: string,
        startTime: string,
        endTime: string,
        week1: boolean,
        week2: boolean,
        week3: boolean,
        week4: boolean,
        week5: boolean,
        sunday: boolean,
        monday: boolean,
        tuesday: boolean,
        wednesday: boolean,
        thursday: boolean,
        friday: boolean,
        saturday: boolean
    }],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export async function getAssessmentSchedule(
    careRecipientId: CareRecipientId
): Promise<GetAssessmentScheduleSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.assessment.schedule,
        {
            care_recipient_id: careRecipientId.value
        },
        () => {},
        () => {}
    );
}

export async function updateAssessmentSchedule(
    careRecipientId: CareRecipientId,
    regularGoingOut: RegularGoingOut[],
    regularVisit: RegularVisit[]
) {
    const body = {
        regularGoingOut: regularGoingOut.map(it =>(
            {
                title: it.title.value,
                startTime: it.startTime.format(),
                endTime: it.endTime.format(),
                week1: it.week1,
                week2: it.week2,
                week3: it.week3,
                week4: it.week4,
                week5: it.week5,
                sunday: it.sunday,
                monday: it.monday,
                tuesday: it.tuesday,
                wednesday: it.wednesday,
                thursday: it.thursday,
                friday: it.friday,
                saturday: it.saturday,
            }
        )),
        regularVisit: regularVisit.map(it =>(
            {
                title: it.title.value,
                startTime: it.startTime.format(),
                endTime: it.endTime.format(),
                week1: it.week1,
                week2: it.week2,
                week3: it.week3,
                week4: it.week4,
                week5: it.week5,
                sunday: it.sunday,
                monday: it.monday,
                tuesday: it.tuesday,
                wednesday: it.wednesday,
                thursday: it.thursday,
                friday: it.friday,
                saturday: it.saturday
            }
        ))
    };
    return await ApiRequest.post(
        ApiPaths.assessment.schedule,
        {
            care_recipient_id: careRecipientId.value
        },
        body,
        () => {},
        () => {}
    );
}
